let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5X9Tc")).then(() => parcelRequire('lhPsg'));